import {Artist} from "src/utils/artist.utils";
import rizuko from "../../../../assets/images/riize/character/character_rizuko.png";
import rizukoThumbnail from "../../../../assets/images/riize/character/thumbnail_rizuko.png";
import songyongdoli from "../../../../assets/images/riize/character/character_songyongdoli.png";
import songyongdoliThumbnail from "../../../../assets/images/riize/character/thumbnail_songyongdoli.png";
import urakbam from "../../../../assets/images/riize/character/character_urakbam.png";
import urakbamThumbnail from "../../../../assets/images/riize/character/thumbnail_urakbam.png";
import tonyangdeok from "../../../../assets/images/riize/character/character_tonyangdeok.png";
import tonyangdeokThumbnail from "../../../../assets/images/riize/character/thumbnail_tonyangdeok.png";
import ddolbyeong from "../../../../assets/images/riize/character/character_ddolbyeong.png";
import ddolbyeongThumbnail from "../../../../assets/images/riize/character/thumbnail_ddolbyeong.png";
import meongryongie from "../../../../assets/images/riize/character/character_meongryongie.png";
import meongryongieThumbnail from "../../../../assets/images/riize/character/thumbnail_meongryongie.png";
import karangi from "../../../../assets/images/aespa/character/character_karangi.png";
import karangiThumbnail from "../../../../assets/images/aespa/character/thumbnail_karangi.png";
import gelbulnyangi from "../../../../assets/images/aespa/character/character_gelbulnyangi.png";
import gelbulnyangiThumbnail from "../../../../assets/images/aespa/character/thumbnail_gelbulnyangi.png";
import mungtaengi from "../../../../assets/images/aespa/character/character_mungtaengi.png";
import mungtaengiThumbnail from "../../../../assets/images/aespa/character/thumbnail_mungtaengi.png";
import rwe from "../../../../assets/images/aespa/character/character_rwe.png";
import rweThumbnail from "../../../../assets/images/aespa/character/thumbnail_rwe.png";

export type CharacterInfo = {
  id: string;
  identifier: string;
  information: Record<
    "ko" | "en",
    {
      name: string;
      personality: string[];
      greeting: string;
    }
  >;
  image: string;
  thumbnail: string;
};

export const CHARACTER_INFO: Record<Artist, CharacterInfo[]> = {
  riize: [
    {
      id: "1",
      identifier: "rizuko",
      information: {
        ko: {
          name: "리즈코",
          personality: ["일상 이야기", "호기심 나누기"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Rizuko",
          personality: ["Everyday stories", "sharing curiosity"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: rizuko,
      thumbnail: rizukoThumbnail,
    },
    {
      id: "2",
      identifier: "songyongdoli",
      information: {
        ko: {
          name: "송용돌이",
          personality: ["조용한 공감", "담백한 위로"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Songyongdoli",
          personality: ["Quiet empathy", "simple comfort"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: songyongdoli,
      thumbnail: songyongdoliThumbnail,
    },
    {
      id: "3",
      identifier: "urakbam",
      information: {
        ko: {
          name: "우락밤",
          personality: ["응원", "힘나는 한마디"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Urakbam",
          personality: ["Encouragement", "uplifting words"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: urakbam,
      thumbnail: urakbamThumbnail,
    },
    {
      id: "4",
      identifier: "tonyangdeok",
      information: {
        ko: {
          name: "토냥덕",
          personality: ["일상 루틴 공유", "잔잔한 동행"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Tonyangdeok",
          personality: ["Sharing daily routines", "gentle companionship"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: tonyangdeok,
      thumbnail: tonyangdeokThumbnail,
    },
    {
      id: "5",
      identifier: "ddolbyeong",
      information: {
        ko: {
          name: "똘병",
          personality: ["농담 섞인 편안한 대화", "가벼운 감정 나누기"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Ddolbyeong",
          personality: [
            "Lighthearted conversation with jokes",
            "sharing small feelings",
          ],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: ddolbyeong,
      thumbnail: ddolbyeongThumbnail,
    },

    {
      id: "6",
      identifier: "meongryongie",
      information: {
        ko: {
          name: "멍룡이",
          personality: ["마음 가라 앉히기", "생각 나누기"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Meongryongie",
          personality: ["Calming the mind", "sharing thoughts"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: meongryongie,
      thumbnail: meongryongieThumbnail,
    },
  ],
  aespa: [
    {
      id: "7",
      identifier: "karangi",
      information: {
        ko: {
          name: "카랑이",
          personality: ["동기부여", "도전", "자신감"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Karangi",
          personality: ["Motivation", "challenge", "confidence"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: karangi,
      thumbnail: karangiThumbnail,
    },
    {
      id: "8",
      identifier: "gelbulnyangi",
      information: {
        ko: {
          name: "젤블냥이",
          personality: ["자유"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Gelbulnyangi",
          personality: ["Freedom"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
      },
      image: gelbulnyangi,
      thumbnail: gelbulnyangiThumbnail,
    },
    {
      id: "9",
      identifier: "mungtaengi",
      information: {
        ko: {
          name: "뭉탱이",
          personality: ["공감", "행복"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Mungtaengi",
          personality: ["Empathy", "happiness"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
      },
      image: mungtaengi,
      thumbnail: mungtaengiThumbnail,
    },
    {
      id: "10",
      identifier: "rwe",
      information: {
        ko: {
          name: "뤠",
          personality: ["사랑", "애정"],
          greeting: `안녕! 나랑 수다 떨 사람!`,
        },
        en: {
          name: "Rwe",
          personality: ["Love", "affection"],
          greeting: `Hi there! Let's chat!`,
        },
      },
      image: rwe,
      thumbnail: rweThumbnail,
    },
  ],
};
